import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getImageSize, PANORAMA_SIZE, VIDEO_SIZE } from '@core/helpers/getSlideSize';
import { MediaInfo, MediaType } from '@core/models/media-info.model';
import Swiper, { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-gallery-dialog',
  templateUrl: './gallery-dialog.component.html',
  styleUrls: ['./gallery-dialog.component.scss']
})
export class GalleryDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('swiper') swiper: any;
  readonly MediaType = MediaType;

  swiperRef: Swiper;
  slidesWidth: any = [];
  width: number;
  isLoading = true;
  activeIndex = 0;
  config: SwiperOptions = {
    centeredSlides: false,
    slidesPerView: 1,
    autoHeight: true,
    allowTouchMove: true,
    navigation: {
      nextEl: '.gallery-dialog__button-next',
      prevEl: '.gallery-dialog__button-prev',
    },
  };

  constructor(
    public dialogRef: MatDialogRef<GalleryDialogComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: { items: MediaInfo[]; index: number; },
  ) { }


  ngOnInit(): void {
    this.activeIndex = this.data.index;

    switch (this.data.items[this.activeIndex].type) {
      case MediaType.Video:
        this.width = getImageSize(VIDEO_SIZE).width;
        break;
      case MediaType.Panorama:
        this.width = getImageSize(PANORAMA_SIZE).width;
        break;
      case MediaType.Image:
        const img: HTMLImageElement = new Image();
        img.src = this.data.items[this.activeIndex].url;

        img.onload = () => {
          this.width = getImageSize({ width: img.width, height: img.height }).width;
        };
        break;

      default:
        break;
    }

  }

  ngAfterViewInit(): void {
    this.swiperRef = this.swiper.swiperRef;
    this.swiperRef.activeIndex = this.activeIndex;
  }


  onSwiper(ev: Swiper) {
    this.swiperRef = ev;
    this.swiperRef.allowTouchMove = this.data.items[this.activeIndex].type !== MediaType.Panorama;
  }

  onSlideChange(swiper: any) {
    this.activeIndex = swiper[0].activeIndex;
    this.swiperRef.allowTouchMove = this.data.items[this.activeIndex].type !== MediaType.Panorama;
    this.width = this.slidesWidth.filter(item => item.index === this.activeIndex)[0].width;
    this.swiperRef.updateSize();
    this.cdr.detectChanges();
  }

  slideEventListener(e) {
    if (this.slidesWidth.length > 0) {
      if (this.slidesWidth.filter(item => item.index === e.index).length === 0) {
        this.slidesWidth.push(e);
      }
    } else {
      this.slidesWidth.push(e);
    }
  }
}


